import React from "react";
import { volumes } from "../data/volumes";
export function VolumesSection() {
  return <section id="volumenes" className="bg-cream-50 py-14 sm:py-28" data-id="element-314" data-mp="3uung4wy156ex">
      <div className="mx-auto max-w-6xl px-5" data-id="element-315" data-mp="3uwgnyfkdpwoi">
        <div className="max-w-3xl" data-id="element-316" data-mp="cng56oqltlbl">
          <h2 className="font-display text-4xl font-semibold leading-tight text-cocoa-900 sm:text-5xl" data-id="element-317" data-mp="cnptm7w03kf6">
            6 volúmenes, <em className="font-medium text-caramel-600" data-id="element-318" data-mp="7nlg8qqe35t6">un solo camino</em>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-cocoa-700" data-id="element-319" data-mp="3g350j0931dw3">
            Cada volumen resuelve una parte del emprendimiento, en el orden en que la necesitas. Lees, aplicas y pasas al siguiente.
          </p>
        </div>

        <ul className="mt-8 grid gap-x-8 gap-y-9 sm:mt-14 sm:gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-320" data-mp="3l3sspp91s0rw">
          {volumes.map(v => <li key={v.number} className="grid grid-rows-[auto_auto_1fr] gap-5" data-id="element-321" data-mp="2xdf7ahkyx06a">
              <BookCover number={v.number} topic={v.topic} image={v.image} imageAlt={v.imageAlt} data-id="element-322" data-mp="2selvqup8rj8r" />
              <div data-id="element-323" data-mp="29eh10hkkl5jv">
                <p className="text-xs font-semibold uppercase tracking-wider text-caramel-600" data-id="element-324" data-mp="29ez5g1hdyq2v">Volumen {v.number} · {v.topic}</p>
                <h3 className="mt-2 font-display text-2xl font-semibold text-cocoa-900" data-id="element-325" data-mp="2ec8qz61nmhlf">{v.title}</h3>
              </div>
              <p className="leading-relaxed text-cocoa-700" data-id="element-326" data-mp="2o451jgkxg06j">{v.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}
type BookCoverProps = {
  number: string;
  topic: string;
  image: string;
  imageAlt: string;
};
function BookCover({
  number,
  topic,
  image,
  imageAlt
}: BookCoverProps) {
  return <div className="relative aspect-[16/10] overflow-hidden rounded-xl bg-cocoa-900 shadow-[0_18px_40px_-20px_rgba(28,17,11,0.8)]" data-id="element-327" data-mp="20dr6dh71pl7q">
      <img src={image} alt={imageAlt} loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-328" data-mp="24hqilnlalxva" />

      <span className="absolute right-3 top-3 flex h-12 w-12 items-center justify-center rounded-full bg-caramel-500 font-display text-xl font-semibold italic text-cocoa-950 shadow-lg" aria-hidden="true" data-id="element-329" data-mp="3bwbt82fpjizm">
        {number}
      </span>

      <div className="absolute bottom-3 left-3 rounded-lg bg-cocoa-950/90 px-4 py-2.5 shadow-lg backdrop-blur-sm" data-id="element-330" data-mp="1bqy6gt18rcee">
        <p className="font-display text-[11px] italic text-caramel-300" data-id="element-331" data-mp="1pqzaghcsyzy3">De tu cocina a tus primeros pedidos</p>
        <p className="font-display text-2xl font-semibold leading-tight text-cream-50" data-id="element-332" data-mp="1kqbi9scu8d2a">{topic}</p>
      </div>
    </div>;
}